import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Channel } from '@doddly/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ly-channel-avatar',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './channel-avatar.component.html',
  styleUrl: './channel-avatar.component.scss',
})
export class ChannelAvatarComponent {
  @Input() channel: Channel | undefined;
  @Input() badge = true;
  @Input() size: 'small' | '' = '';
}
